export default "__VITE_ASSET__D5c2Dwyn__"